import { render } from "./MessageTail.vue?vue&type=template&id=a9df8284&scoped=true&ts=true"
import script from "./MessageTail.vue?vue&type=script&lang=ts"
export * from "./MessageTail.vue?vue&type=script&lang=ts"

import "./MessageTail.vue?vue&type=style&index=0&id=a9df8284&lang=scss&scoped=true"

import exportComponent from "/builds/root/dev.front.widget/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9df8284"]])

export default __exports__